module.exports = __webpack_public_path__ + "static/img/pepay-cir.377bb52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/pepay-cir.png
// module id = 1yvj
// module chunks = 0